import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { Categoria, Item, Blobs, Iva, Um, 
  BlobService, ItemsService, UmService, IvaService } from 'my-lib-sanfelici';
import { CategorieService } from 'my-lib-sanfelici';




@Component({
  selector: 'app-items-create',
  templateUrl: './items-create.component.html',
  styleUrls: ['./items-create.component.css']
})
export class ItemsCreateComponent implements OnInit {
  item: Item;
  ums: Observable<Um[]>;
  ives: Observable<Iva[]>;
  categorie: Observable<Categoria[]>;
  images: Observable<Blobs[]>;
  constructor(
    private itemsservice: ItemsService,
    private categorieservice: CategorieService,
    private ivaservice: IvaService,
    private imagesservice: BlobService,
    private umservice: UmService
  ) { }
  onSubmit() {
    this.itemsservice.create(this.item).then(i => console.log(this.item));

  }
  ngOnInit() {
    this.item = {id: null,
      descrizione: null,
      prezzo: null,
      Um:null,
      iva_id: null,image_id:null,
    categoria_id: null};
    this.ums = this.umservice.list();
    this.ives = this.ivaservice.list();
    this.categorie = this.categorieservice.list();
    this.images = this.imagesservice.getimages();
  }

}
